/*
  饼干模具 · 实时压印预览（配合 sections/fn-biscuit-preview.liquid）
  - 顾客第一次在 PatchStitch 定制框里输入或选款式时，把预览叠到商品第 1 张图上，并把图库切到第 1 张
  - 手机上图库在页面上方，输入时右上角浮出小预览，停止输入几秒后收起
  - 定制项按标题对应（去掉重音、大小写和必填星号后比较）；Loomina 里改了标题，这里要同步改
  - 坐标都是商品原图 1254×1254 像素坐标，按原图量过：底图和第 1 张图逐像素对齐
*/
(function () {
  'use strict';
  var SVGNS = 'http://www.w3.org/2000/svg';

  /* 「La Famille Dubois」→ La / Famille / Dubois；et、de、du、des 跟后一个词同一行 */
  var LINK = /^(et|&|de|du|des|d’|d')$/i;
  function splitName(v) {
    var w = [];
    v.trim().split(/\s+/).filter(Boolean).forEach(function (t) {
      var prev = w[w.length - 1];
      if (prev && LINK.test(prev)) w[w.length - 1] = prev + ' ' + t; else w.push(t);
    });
    if (w.length <= 2) return w;
    return [w.slice(0, -2).join(' '), w[w.length - 2], w[w.length - 1]];
  }

  /* 按商品 ID 配置。fields：key → 定制项标题（可多个，兼容改名前后）+ 没输入时显示的默认文字 */
  var PRODUCTS = {
    '10159118516471': { spu: '945',
      fields: { haut: { titles: ['texte du haut'], def: 'NOTRE PREMIER' },
                sous: { titles: ['texte sous'], def: '' },
                p1: { titles: ['prenom 1'], def: 'OLIVIA' },
                p2: { titles: ['prenom 2'], def: 'DAVID' },
                bas: { titles: ['texte du bas'], def: '' } },
      draw: function (v, s) {
        /* 整个印章跟着饼干顺时针转了约 5° */
        var serif = { font: 'Libre Baskerville', weight: 700 };
        s.arc(v.haut, { cx: 668, cy: 611, r: 238, side: 'top', maxW: 520, rotate: 5 }, { font: serif.font, weight: 700, size: 54 });
        if (v.sous.trim()) s.text(v.sous, { x: 670, y: 746, size: 100, maxW: 500, font: serif.font, weight: 700, ls: 5, rotate: [4.5, 670, 710] });
        s.text(v.p1, { x: 484, y: 822, size: 50, maxW: 190, font: serif.font, weight: 700, rotate: [6, 484, 805] });
        s.text(v.p2, { x: 818, y: 862, size: 50, maxW: 180, font: serif.font, weight: 700, rotate: [5, 818, 845] });
        if (v.bas.trim()) s.text(v.bas, { x: 640, y: 934, size: 54, maxW: 280, font: serif.font, weight: 700, rotate: [5.8, 640, 915] });
      } },
    '10159119270135': { spu: '948',
      fields: { msg: { titles: ['message personnalise'], def: 'JOYEUX NOËL' },
                nom: { titles: ['nom de famille'], def: 'La famille Williams' } },
      draw: function (v, s) {
        s.arc(v.msg, { cx: 622, cy: 805, r: 420, side: 'top', maxW: 740 }, { font: 'Montserrat', weight: 600, size: 82, ls: 2, caps: true });
        var parts = splitName(v.nom);
        var L = { 1: [[622, 770, 230, 700]], 2: [[622, 650, 200, 660], [636, 860, 200, 640]], 3: [[622, 560, 160, 420], [622, 735, 186, 640], [640, 918, 190, 620]] }[parts.length] || [];
        parts.forEach(function (p, i) { s.text(p, { x: L[i][0], y: L[i][1], size: L[i][2], maxW: L[i][3], font: 'Satisfy' }); });
      } },
    '10159118614775': { spu: '947',
      fields: { haut: { titles: ['texte du haut'], def: 'JOYEUX NOËL' },
                bas: { titles: ['texte du bas'], def: 'Les Dubois' } },
      draw: function (v, s) {
        s.arc(v.haut, { cx: 674, cy: 582, r: 212, side: 'top', maxW: 560 }, { font: 'Montserrat', weight: 700, size: 78, ls: 4, caps: true });
        s.arc(v.bas, { cx: 665, cy: 735, r: 300, side: 'bottom', maxW: 600 }, { font: 'Montserrat', weight: 700, size: 78, ls: 4 });
      } },
    '10159119040759': { spu: '949',
      fields: { modele: { titles: ['choisir le modele'], choice: true, def: 'garcon' },
                prenom: { titles: ['prenom', 'nom'], def: 'Léo' } },
      draw: function (v, s) {
        var girl = /fille/i.test(v.modele);
        if (girl) s.text(v.prenom, { x: 926, y: 722, size: 80, maxW: 300, font: 'Montserrat', weight: 600, ls: 1, rotate: [1, 926, 700] });
        else s.text(v.prenom, { x: 346, y: 686, size: 80, maxW: 310, font: 'Montserrat', weight: 600, ls: 1, rotate: [-0.6, 346, 660] });
      } },
    '10159118844151': { spu: '944',
      fields: { nom: { titles: ['nom de famille'], def: 'Les Martin' } },
      draw: function (v, s) {
        /* 「Joyeux Noël」已在底图上；顾客的文字排在下面，跟着饼干倾斜 */
        var rot = [-9, 835, 810];
        var w = v.nom.trim().split(/\s+/).filter(Boolean);
        var lines = w.length > 1 ? [w.slice(0, -1).join(' '), w[w.length - 1]] : w;
        var L = lines.length > 1 ? [[834, 818, 78, 300], [834, 905, 84, 270]] : [[836, 868, 96, 290]];
        lines.forEach(function (t, i) { s.text(t, { x: L[i][0], y: L[i][1], size: L[i][2], maxW: L[i][3], font: 'Tinos', rotate: rot }); });
      } }
  };

  function norm(s) {
    return (s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[*’']/g, ' ').replace(/\s+/g, ' ').trim().toLowerCase();
  }
  function el(tag, attrs, parent) {
    var e = document.createElementNS(SVGNS, tag);
    for (var k in attrs) e.setAttribute(k, attrs[k]);
    if (parent) parent.appendChild(e);
    return e;
  }

  /* 共用的压印滤镜：凹槽颜色按 948 原图取样（压印图 ÷ 空白底图） */
  function filters() {
    if (document.getElementById('fn-bp-groove')) return;
    var svg = el('svg', { width: 0, height: 0, 'aria-hidden': 'true', style: 'position:absolute' });
    svg.innerHTML =
      '<defs>' +
      '<filter id="fn-bp-groove" x="-5%" y="-5%" width="110%" height="110%" color-interpolation-filters="sRGB">' +
        '<feMorphology in="SourceAlpha" operator="dilate" radius=".6" result="a"/>' +
        '<feFlood flood-color="rgb(205,160,80)"/><feComposite in2="a" operator="in" result="floor"/>' +
        '<feGaussianBlur in="a" stdDeviation="2.4" result="blur"/><feOffset in="blur" dx="3" dy="5" result="shift"/>' +
        '<feComposite in="a" in2="shift" operator="out" result="wall"/><feGaussianBlur in="wall" stdDeviation=".8" result="wallSoft"/>' +
        '<feFlood flood-color="rgb(160,104,24)"/><feComposite in2="wallSoft" operator="in" result="shade"/>' +
        '<feMerge result="m"><feMergeNode in="floor"/><feMergeNode in="shade"/></feMerge><feGaussianBlur in="m" stdDeviation=".4"/>' +
      '</filter>' +
      '<filter id="fn-bp-lip" x="-5%" y="-5%" width="110%" height="110%" color-interpolation-filters="sRGB">' +
        '<feOffset in="SourceAlpha" dx="2" dy="4" result="down"/><feComposite in="down" in2="SourceAlpha" operator="out" result="rim"/>' +
        '<feGaussianBlur in="rim" stdDeviation="1.6" result="rimSoft"/><feFlood flood-color="rgb(150,130,110)"/><feComposite in2="rimSoft" operator="in"/>' +
      '</filter></defs>';
    document.body.appendChild(svg);
  }

  /* 一个画面：底图 + 两层引用同一组文字的压印（正片叠底压暗 + 滤色提亮） */
  function scene(img) {
    var svg = el('svg', { viewBox: '0 0 1254 1254', 'aria-hidden': 'true' });
    el('image', { href: img, width: 1254, height: 1254 }, svg);
    el('use', { href: '#fn-bp-type', filter: 'url(#fn-bp-groove)', style: 'mix-blend-mode:multiply' }, svg);
    el('use', { href: '#fn-bp-type', filter: 'url(#fn-bp-lip)', style: 'mix-blend-mode:screen' }, svg);
    return { svg: svg };
  }

  function boot(host) {
    var cfg = PRODUCTS[host.getAttribute('data-product-id')];
    if (!cfg) return;
    var imgs = JSON.parse(host.querySelector('[data-fn-bp-imgs]').textContent);
    var pdp = document.querySelector('[data-fn-pdp]');
    var slide = pdp && pdp.querySelector('[data-fn-gal-track] > .fn-gal__slide');
    if (!slide) return;
    filters();

    /* 大图：叠在第 1 张商品图上 */
    var wrap = document.createElement('div'); wrap.className = 'fn-bp';
    var big = scene(imgs[cfg.spu]);
    /* 不可见的测量层：文字在这里排版和量宽度，两层压印用 <use> 引用它 */
    var hold = el('g', { opacity: 0 }, big.svg);
    var type = el('g', { id: 'fn-bp-type' }, hold);
    var defs = el('defs', {}, big.svg);
    wrap.appendChild(big.svg);
    wrap.insertAdjacentHTML('beforeend', '<span class="fn-bp__badge"><i></i></span><span class="fn-bp__note"></span>');
    wrap.querySelector('.fn-bp__badge').appendChild(document.createTextNode(host.getAttribute('data-label') || ''));
    wrap.querySelector('.fn-bp__note').textContent = host.getAttribute('data-note') || '';
    slide.appendChild(wrap);

    /* 小图：手机上输入时浮在右上角 */
    var mini = document.createElement('div'); mini.className = 'fn-bp-mini';
    var small = scene(imgs[cfg.spu]);
    mini.appendChild(small.svg); document.body.appendChild(mini);

    var values = {};
    function titleOf(opt) {
      var t = opt.querySelector('.ps-option__title');
      return norm(t && t.firstChild ? t.firstChild.textContent : '');
    }
    function matches(f, title) { return f.titles.some(function (x) { return title === x || title.indexOf(x) === 0; }); }
    function read() {
      var root = document.querySelector('[data-patchstitch-root]');
      Object.keys(cfg.fields).forEach(function (k) { values[k] = cfg.fields[k].def; });
      if (!root) return;
      root.querySelectorAll('.ps-option').forEach(function (opt) {
        var title = titleOf(opt);
        Object.keys(cfg.fields).forEach(function (k) {
          var f = cfg.fields[k];
          if (!matches(f, title)) return;
          if (f.choice) {
            var c = opt.querySelector('.ps-choice[data-selected="true"]');
            if (c) values[k] = c.getAttribute('title') || '';
          } else {
            var inp = opt.querySelector('.ps-text-input, textarea');
            if (inp && inp.value.trim()) values[k] = inp.value;
          }
        });
      });
    }

    function fit(t, size, maxW) {
      t.setAttribute('font-size', size);
      var w = t.getComputedTextLength();
      if (w <= maxW) return;
      t.setAttribute('font-size', Math.max(size * 0.45, size * maxW / w).toFixed(1));
      if (t.getComputedTextLength() > maxW) { t.setAttribute('textLength', maxW); t.setAttribute('lengthAdjust', 'spacingAndGlyphs'); }
    }
    function arcD(a) {
      var s = 80 * Math.PI / 180, r = a.r, dx = r * Math.sin(s), dy = r * Math.cos(s);
      if (a.side === 'top') return 'M' + (a.cx - dx) + ' ' + (a.cy - dy) + ' A' + r + ' ' + r + ' 0 0 1 ' + (a.cx + dx) + ' ' + (a.cy - dy);
      return 'M' + (a.cx - dx) + ' ' + (a.cy + dy) + ' A' + r + ' ' + r + ' 0 0 0 ' + (a.cx + dx) + ' ' + (a.cy + dy);
    }
    var painter = {
      n: 0,
      text: function (str, o) {
        var t = el('text', { x: o.x, y: o.y, 'text-anchor': 'middle', 'font-family': o.font, 'font-weight': o.weight || 400, 'letter-spacing': o.ls || 0 }, type);
        if (o.rotate) t.setAttribute('transform', 'rotate(' + o.rotate.join(' ') + ')');
        t.textContent = o.caps ? str.toUpperCase() : str;
        fit(t, o.size, o.maxW);
      },
      arc: function (str, a, o) {
        var id = 'fn-bp-arc' + (painter.n++);
        el('path', { id: id, d: arcD(a), fill: 'none' }, defs);
        var t = el('text', { 'font-family': o.font, 'font-weight': o.weight || 400, 'letter-spacing': o.ls || 0 }, type);
        if (a.rotate) t.setAttribute('transform', 'rotate(' + a.rotate + ' ' + a.cx + ' ' + a.cy + ')');
        var tp = el('textPath', { href: '#' + id, startOffset: '50%', 'text-anchor': 'middle' }, t);
        tp.textContent = o.caps ? str.toUpperCase() : str;
        fit(t, o.size, a.maxW);
      }
    };
    function draw() {
      read();
      type.textContent = ''; defs.textContent = ''; painter.n = 0;
      cfg.draw(values, painter);
    }

    var started = false, hideT;
    function slideVisible() {
      var r = slide.getBoundingClientRect();
      return r.bottom > 80 && r.top < window.innerHeight - 80 && r.left >= -10 && r.right <= window.innerWidth + 10;
    }
    function touched() {
      draw();
      if (!started) {
        started = true; wrap.classList.add('is-on');
        /* 图库切到第 1 张（缩略图点击会触发主题自己的切换逻辑） */
        var th = pdp.querySelector('.fn-gal__thumb[data-go="0"]');
        if (th && th.getAttribute('aria-selected') !== 'true') th.click();
      }
      if (!slideVisible()) { mini.classList.add('is-on'); clearTimeout(hideT); hideT = setTimeout(function () { mini.classList.remove('is-on'); }, 2500); }
      else mini.classList.remove('is-on');
    }

    /* PatchStitch 每次输入都会重建选项 DOM，冒泡到 document 时输入框可能已经不在页面上：
       用捕获阶段判断来源，等它重建完再读值 */
    document.addEventListener('input', function (e) {
      if (e.target.closest && e.target.closest('[data-patchstitch-root]')) setTimeout(touched, 0);
    }, true);
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-patchstitch-root] .ps-choice')) setTimeout(touched, 0);
    }, true);
    /* 字体是异步加载的，加载完要重新量一次宽度 */
    if (document.fonts) { document.fonts.ready.then(draw); document.fonts.addEventListener('loadingdone', draw); }
    draw();
  }

  /* 推荐写法小按钮（所有用这个区块的商品通用，和预览无关）
     推荐写法在 Loomina 定制项的「提示」里管理，写在最后：「… Idées : A | B | C」。
     PatchStitch 不会同步文字定制项的 hint_text，所以借用提示字段；这里把「Idées」那段从提示里拿掉，变成可点的按钮。
     PatchStitch 每次输入都会重建选项 DOM，所以用 MutationObserver 在绘制前重新处理（回调是微任务，提示原文不会闪出来） */
  var IDEAS = /\s*Id[ée]es\s*:\s*(.+)$/i;
  function ideas() {
    var root = document.querySelector('[data-patchstitch-root]');
    if (!root) return;
    root.querySelectorAll('.ps-option').forEach(function (opt) {
      var tip = opt.querySelector('.ps-option__tooltip');
      var inp = opt.querySelector('.ps-text-input');
      if (!tip || !inp) return;
      var m = tip.textContent.match(IDEAS);
      if (m) {
        var rest = tip.textContent.replace(IDEAS, '').trim();
        tip.setAttribute('data-fn-ideas', m[1]);
        tip.textContent = rest; tip.hidden = !rest;
      }
      if (!tip.hasAttribute('data-fn-ideas')) return;
      var box = opt.querySelector('.fn-bp-chips');
      if (!box) {
        box = document.createElement('div'); box.className = 'fn-bp-chips'; box.setAttribute('aria-label', 'Idées');
        tip.getAttribute('data-fn-ideas').split('|').map(function (c) { return c.trim(); }).filter(Boolean).forEach(function (c) {
          var b = document.createElement('button'); b.type = 'button'; b.textContent = c;
          b.addEventListener('click', function () {
            /* 点击时重新找输入框：PatchStitch 可能已经换了一个新的 */
            var o = b.closest('.ps-option'), i = o && o.querySelector('.ps-text-input'); if (!i) return;
            Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set.call(i, c.slice(0, i.maxLength > 0 ? i.maxLength : c.length));
            i.dispatchEvent(new Event('input', { bubbles: true }));
          });
          box.appendChild(b);
        });
        (opt.querySelector('.ps-text-input-wrap') || inp).insertAdjacentElement('afterend', box);
      }
      box.querySelectorAll('button').forEach(function (b) {
        var on = String(b.textContent === inp.value);
        if (b.getAttribute('aria-pressed') !== on) b.setAttribute('aria-pressed', on);
      });
    });
  }

  function scan() {
    document.querySelectorAll('[data-fn-bp]').forEach(function (h) { if (!h.dataset.fnReady) { h.dataset.fnReady = '1'; boot(h); } });
    if (document.querySelector('[data-fn-bp]') && !scan.ideas) {
      scan.ideas = true;
      new MutationObserver(ideas).observe(document.body, { childList: true, subtree: true });
      ideas();
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
})();
